class CookieService {
  setValue(name: string, value: string, options: any) {
    localStorage.setItem(name, value);
  }

  getValue(name: any) {
    const value = localStorage.getItem(name);
    if (value) {
      return value;
    } else {
      return null;
    }
  }

  removeValue(name: any) {
    localStorage.removeItem(name);
  }

  isItemAvailable(name: any) {
    return Boolean(this.getValue(name));
  }
}

const cookieService = new CookieService();

Object.freeze(cookieService);

export default cookieService;
